import axios from 'axios';

const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const http = axios.create({
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token,
    },
  });
export default http;
